export default __webpack_public_path__ + "img/Montserrat-Medium_693c527.ttf";